import {
  afterNextRender,
  Directive,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appScrollToTop]',
  standalone: true,
})
export class ScrollToTopDirective implements OnDestroy {
  @Input()
  set appScrollToTop(active: string | boolean) {
    this.active = typeof active === 'string' ? active.length === 0 : active;
  }

  private active: boolean = true;
  private timeoutId: number | null = null;

  private onClick: EventListener = (event: any) => {
    if (this.active && isPlatformBrowser(this.platformId)) {
      // Clear any existing timeout to prevent multiple queued operations
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
      }

      this.timeoutId = window.setTimeout(() => {
        const header = document.getElementById('hero_sec');
        if (header) {
          header.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
        this.timeoutId = null;
      }, 250);
    }
  };

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly elementRef: ElementRef,
  ) {
    afterNextRender(() => {
      this.elementRef.nativeElement.addEventListener(
        'click',
        this.onClick,
        false,
      );
    });
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Clear any pending timeout when the directive is destroyed
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.elementRef.nativeElement.removeEventListener(
        'click',
        this.onClick,
        false,
      );
    }
  }
}
